export default "__VITE_ASSET__BeCjSUh0__"